<template>
  <v-dialog
    @keydown.esc='onOkClickButton'
    :value="visiblePopup"
    @click:outside="onOkClickButton"
    :max-width="730"
  >
    <v-card class="popup-wrapper">
      <div class="title">{{$t(title)}}</div>
      <div class="message">
        <div v-for='(source, index) in data' class='leak-source-content' :key='`leak-source-content-${index}`' >
          <div class='leak-source-content__subtitle'>
            {{source.leakName}}<br />
          </div>
          <div class='leak-source-content__description' v-html='source.description' />
        </div>
      <div class="buttons">
        <v-btn small depressed class="yes-button btn-primary" @click="onOkClickButton()">
          {{$t(okCaption)}}
        </v-btn>
      </div>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>

import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'LeakSourceHelpPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    data: {
      type: Array,
      required: true,
    },
    visiblePopup: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    title() {
      return 'employees.leak.source.help.popup.title';
    },
    okCaption() {
      return 'confirm.ok';
    },
  },
  methods: {
    onOkClickButton() {
      this.$emit('clicked', true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.popup-wrapper {
  max-width: rem(730);
  padding: $space-8 $space-10;
  .leak-source-content {
    &__subtitle{
      color: var(--text-secondary);
      font-family: $font-family-medium;
      text-transform: uppercase;
      font-size: $font-size-sm;
      line-height: $space-5;
      letter-spacing: 0;
      padding-bottom: $space-1-5;
    }
    &__description{
      font-family: $font-family-regular;
      padding-bottom: rem(10);
    }
  }
  .title {
    color: var(--text-primary);
    font-size: rem(24);
    font-family: $font-family-bold;
    letter-spacing: 1.12px;
    line-height: $space-4;
    text-transform: uppercase;
    padding-bottom: rem(23);
  }

  .message {
    font-size: $font-size-base;
    line-height: 1.36;
    font-weight: normal;
    color: var(--text-primary);
    letter-spacing: 0;
    line-height: rem(18);
  }
  .buttons {
    text-align: right;
    padding-top: rem(30);
    .yes-button {
      height: $btn-height-md;
      width: rem(51);
      border-radius: $radius-sm;
      background-color: var(--brand-primary) !important;
      box-shadow: $shadow-sm;
      color: var(--text-inverse);
      font-size: $font-size-xs;
      font-weight: 500;
      letter-spacing: 1.07px;
      line-height: $space-4;
      text-align: center;
      margin-left: $space-2;
    }
  }
}

</style>
